module.exports = __webpack_public_path__ + "img/agent2.11f95f19.png";